import { CloudRain } from 'lucide-react';

/** Marks a planned visit as the rain event inspection the inspector was alerted to. */
export function RainEventChip() {
  return (
    <span className="inline-flex items-center gap-1 text-xs px-1.5 py-0.5 rounded-full font-medium bg-sky-100 dark:bg-sky-900/30 text-sky-700 dark:text-sky-300 whitespace-nowrap">
      <CloudRain className="w-3 h-3" />
      Rain event
    </span>
  );
}
